/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_FinishingInputs */

const en_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishing...`)
};

const de_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird abgeschlossen...`)
};

const fr_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalisation...`)
};

const es_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizando...`)
};

const it_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamento...`)
};

const nl_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afmaken...`)
};

const pl_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kończenie...`)
};

const fi_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmistellaan...`)
};

const da_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afslutter...`)
};

const sv_onboarding_complete_finishing = /** @type {(inputs: Onboarding_Complete_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avslutar...`)
};

/**
* | output |
* | --- |
* | "Finishing..." |
*
* @param {Onboarding_Complete_FinishingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_finishing = /** @type {((inputs?: Onboarding_Complete_FinishingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_FinishingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_finishing(inputs)
	if (locale === "fr") return fr_onboarding_complete_finishing(inputs)
	if (locale === "es") return es_onboarding_complete_finishing(inputs)
	if (locale === "it") return it_onboarding_complete_finishing(inputs)
	if (locale === "nl") return nl_onboarding_complete_finishing(inputs)
	if (locale === "pl") return pl_onboarding_complete_finishing(inputs)
	if (locale === "fi") return fi_onboarding_complete_finishing(inputs)
	if (locale === "da") return da_onboarding_complete_finishing(inputs)
	if (locale === "sv") return sv_onboarding_complete_finishing(inputs)
	return en_onboarding_complete_finishing(inputs)
});